import { useNavigate } from "react-router-dom";

export const useFooter = () => {
  const navigate = useNavigate();
  return { navigate };
};
